/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TeachingTableGamesStatus {
  inProgress = 'inProgress',
  live = 'live',
  startsSoon = 'startsSoon',
  upcoming = 'upcoming'
}

/**
 * TeachingTableGamesStatus
 *
 * Teaching table game status
 */
export const TeachingTableGamesStatusEnumType = types.enumeration('TeachingTableGamesStatus', [
  'inProgress',
  'live',
  'startsSoon',
  'upcoming'
])
